export var AuditLogInitiatorType;
(function (AuditLogInitiatorType) {
    AuditLogInitiatorType["User"] = "USER";
    AuditLogInitiatorType["ApiClient"] = "API_CLIENT";
})(AuditLogInitiatorType || (AuditLogInitiatorType = {}));
